var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Styles from "./CircularProgress.module.css";
const CircularProgress = (_a) => {
    var { className = "", color = "#0d6efd", width = "3em", height = "3em", style, duration = "2s" } = _a, others = __rest(_a, ["className", "color", "width", "height", "style", "duration"]);
    return (React.createElement("svg", Object.assign({}, others, { crossOrigin: "anonymous", viewBox: "25 25 50 50", style: Object.assign(Object.assign({}, style), { ["--width"]: width, ["--height"]: height, ["--color"]: color, ["--duration"]: duration }), className: `${Styles.svg} ${className}` }),
        React.createElement("circle", { className: Styles.circle, cx: "50", cy: "50", r: "20" })));
};
export default CircularProgress;
//# sourceMappingURL=index.js.map